export const SAVE_POOL_LIST = 'SAVE_POOL_LIST'
export const SET_POOL_LOADING = 'SET_POOL_LOADING'
export const CLEAR_POOL_LIST = 'CLEAR_POOL_LIST'
